import {DistinctDomainWithChainIndex} from 'antibodies/AntibodyTypedefs';
import {TranslationParameters} from 'antibodies/nested-data-creation/constants/AntibodyNestedDataCreationConstants';
import * as TaskRunner from 'util/TaskRunner';

export interface DefinedConstantDomainEntity extends DistinctDomainWithChainIndex {
  aaSequenceId: string;
}

export interface CreateAntibodiesFromDnaPairsInput {
  dnaPairIds: Array<string>;
  constantDomains: Array<DefinedConstantDomainEntity>;
  folderId: string;
  registryId: string;
  formatId: string;
  translationParameters: TranslationParameters;
}

/**
 * Creates antibodies from the provided DNA pair IDs.
 *
 * @param dnaPairIds - List of API IDs for DNA pairs to convert to antibodies
 * @param constantDomains - List of which AA sequences to use as the constant domains
 * @param folderId - folder where all new entities will be created
 * @param registryId - registry to use
 * @param formatId - format to use for new antibodies
 * @param translationParameters - parameters for translating DNA to amino acids
 */
export function createAntibodiesFromDnaPairs({
  dnaPairIds,
  constantDomains,
  folderId,
  registryId,
  formatId,
  translationParameters,
}: CreateAntibodiesFromDnaPairsInput): Promise<{createdAllEntities: boolean}> {
  return TaskRunner.postJSONPromise({
    url: '/1/api/antibodies:nested-create-and-register',
    data: {
      dnaPairIds,
      constantDomains: constantDomains.map((domain) => ({
        type: domain.type,
        specificity: domain.specificity,
        aaSequenceId: domain.aaSequenceId,
      })),
      folderId,
      registryId,
      formatId,
      translationParameters,
    },
  });
}
